import { render, staticRenderFns } from "./CatalogPopup.vue?vue&type=template&id=9fd4102c&scoped=true&"
import script from "./CatalogPopup.vue?vue&type=script&lang=js&"
export * from "./CatalogPopup.vue?vue&type=script&lang=js&"
import style0 from "./CatalogPopup.vue?vue&type=style&index=0&id=9fd4102c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd4102c",
  null
  
)

export default component.exports